/**
 * Line2D property formatter: vertex count, width, colour and closed, then the
 * formatNode2DProperties sections.
 */
import { formatNode2DProperties } from '../../base/node2d/propertyFormatter';
export function formatLine2DProperties(properties) {
    const sections = [];
    const { defaultColor, width, closed } = properties;
    const vertexCount = Math.floor(properties.points.length / 2);
    sections.push({
        title: 'Line',
        items: [
            { label: 'Vertex Count', value: String(vertexCount) },
            { label: 'Width', value: String(width) },
            {
                label: 'Color',
                value: `(${defaultColor.r}, ${defaultColor.g}, ${defaultColor.b}, ${defaultColor.a})`,
            },
            { label: 'Closed', value: closed ? 'true' : 'false' },
        ],
    });
    sections.push(...formatNode2DProperties(properties));
    return sections;
}
//# sourceMappingURL=propertyFormatter.js.map